export default "__VITE_ASSET__B__w7t_G__"